"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("./store/store");
exports.findFavoritesStore = store_1.default;
var setFindText_1 = require("./actions/setFindText");
exports.setFindText = setFindText_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-find-favorites-store/lib/index.js
// module id = 3945
// module chunks = 68